import React, { useCallback, useEffect, useState } from 'react';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const PURCHASE_URL = 'https://ahorro-total-2.myshopify.com/cart/44075741741116:1';
const notifications = [{
  name: 'María',
  city: 'Córdoba',
  minutes: 3
}, {
  name: 'Carlos',
  city: 'Rosario',
  minutes: 7
}, {
  name: 'Luciana',
  city: 'Buenos Aires',
  minutes: 12
}, {
  name: 'Fernando',
  city: 'Mendoza',
  minutes: 5
}, {
  name: 'Andrea',
  city: 'Tucumán',
  minutes: 9
}, {
  name: 'Jorge',
  city: 'La Plata',
  minutes: 2
}, {
  name: 'Silvia',
  city: 'Mar del Plata',
  minutes: 15
}, {
  name: 'Diego',
  city: 'Santa Fe',
  minutes: 4
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const showNext = useCallback(() => {
    if (isDismissed) return;
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
      }, 600);
    }, 4000);
  }, [isDismissed]);
  useEffect(() => {
    const startTimer = setTimeout(() => {
      setHasStarted(true);
      showNext();
    }, 5000);
    return () => clearTimeout(startTimer);
  }, [showNext]);
  useEffect(() => {
    if (!hasStarted || isDismissed) return;
    const interval = setInterval(() => {
      showNext();
    }, 7000);
    return () => clearInterval(interval);
  }, [hasStarted, isDismissed, showNext]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-18">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50" style={{
      maxWidth: 'calc(100vw - 32px)'
    }} data-id="element-19">
          <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="block no-underline" data-id="element-20">
            <div className="bg-[#1e293b] border border-[rgba(59,130,246,0.2)] rounded-xl p-4 shadow-2xl shadow-black/50 backdrop-blur-sm" data-id="element-21">
              <button onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            setIsDismissed(true);
            setIsVisible(false);
          }} className="absolute -top-2 -right-2 w-6 h-6 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center transition-colors border-0 cursor-pointer" aria-label="Cerrar notificación" data-id="element-22">
                <XIcon className="w-3 h-3 text-white" data-id="element-23" />
              </button>
              <div className="flex items-center gap-3" data-id="element-24">
                <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-25">
                  <ShoppingBagIcon className="w-5 h-5 text-brand-darker" data-id="element-26" />
                </div>
                <div data-id="element-27">
                  <p className="text-white text-sm font-semibold font-body leading-tight m-0" data-id="element-28">
                    🔥 {current.name} de {current.city}
                  </p>
                  <p className="text-gray-400 text-xs font-body m-0 mt-0.5" data-id="element-29">
                    compró la guía hace {current.minutes} minutos
                  </p>
                </div>
              </div>
            </div>
          </a>
        </motion.div>}
    </AnimatePresence>;
}